import { useState, useEffect } from "react";
import { getUsersAdmin } from "../../api";
import {
  Table,
  Title,
  Grid,
  Pagination,
  TextInput,
  Button,
  Select,
  Group,
  NumberFormatter,
} from "@mantine/core";
import UserDetails from "./UserDetails";
import { useLocation } from "wouter";

export default function Users() {
  const [users, setUsers] = useState({ totalCount: 0, data: [] });
  const [selectedUser, setSelectedUser] = useState(null);
  const [activePage, setPage] = useState(1);
  const pageSize = 25;

  const [search, setSearch] = useState("");
  const [roleFilter, setRoleFilter] = useState("");
  const [planFilter, setPlanFilter] = useState("");

  const [, setLocation] = useLocation();

  useEffect(() => {
    getUsersAdmin(activePage, pageSize, search, roleFilter, planFilter).then(
      (data) => {
        setUsers(data);
      }
    );
  }, [activePage, search, roleFilter, planFilter]);

  if (selectedUser)
    return (
      <UserDetails user={selectedUser} onClose={() => setSelectedUser(null)} />
    );

  return (
    <Grid>
      <Grid.Col span={12}>
        <Title order={1}>{users.totalCount} Users</Title>
      </Grid.Col>
      <Grid.Col span={12}>
        <Group>
          <Pagination
            hideWithOnePage
            total={Math.ceil(users.totalCount / pageSize)}
            value={activePage}
            onChange={setPage}
          />

          <TextInput
            placeholder="Search"
            value={search}
            onChange={(e) => setSearch(e.currentTarget.value)}
          />

          <Select
            value={planFilter}
            onChange={setPlanFilter}
            allowDeselect={false}
            data={[
              { label: "All", value: "" },
              { label: "Free", value: "Free" },
              { label: "Prepaid", value: "Prepaid" },
              { label: "Basic", value: "Basic" },
              { label: "Pro", value: "Pro" },
              { label: "Premium", value: "Premium" },
            ]}
          />

          <Select
            value={roleFilter}
            onChange={setRoleFilter}
            allowDeselect={false}
            data={[
              { label: "All", value: "" },
              { label: "User", value: "User" },
              { label: "Admin", value: "Admin" },
            ]}
          />

          <Button
            onClick={() => {
              getUsersAdmin(1, pageSize, search, roleFilter, planFilter).then(
                (data) => {
                  setUsers(data);
                }
              );
            }}
          >
            Search
          </Button>
        </Group>

        <Table stickyHeader stickyHeaderOffset={60}>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Created</Table.Th>
              <Table.Th>Name</Table.Th>
              <Table.Th>Role</Table.Th>
              <Table.Th>Email</Table.Th>
              <Table.Th>LoginName</Table.Th>
              <Table.Th>Plan</Table.Th>
              <Table.Th>Credits</Table.Th>
              <Table.Th>Credits T.</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {users?.data?.map((p) => (
              <Table.Tr
                key={p.id}
                onClick={() => setLocation(`/admin/users/${p.id}`)}
                bg={
                  selectedUser == p
                    ? "var(--mantine-color-blue-light)"
                    : undefined
                }
              >
                <Table.Td>{p.created}</Table.Td>
                <Table.Td>
                  {p.firstName} {p.lastName}
                </Table.Td>
                <Table.Td>{p.userRole}</Table.Td>
                <Table.Td>{p.email}</Table.Td>
                <Table.Td>{p.loginName}</Table.Td>
                <Table.Td>{p.claims?.Plan}</Table.Td>
                <Table.Td ta="right">
                  <NumberFormatter
                    value={p.credits
                      .filter((p) => p.type === "Generic")
                      .reduce((a, b) => a + b.amount, 0)}
                    thousandSeparator
                  />
                </Table.Td>
                <Table.Td ta="right">
                  <NumberFormatter
                    value={p.credits
                      .filter((p) => p.type === "Training")
                      .reduce((a, b) => a + b.amount, 0)}
                    thousandSeparator
                  />
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </Grid.Col>
    </Grid>
  );
}
